import { useState, useEffect, useCallback } from 'react';
import {
  ArrowLeft, Save, Eye, Globe, Upload, Plus, Trash2,
  GripVertical, Image, Video, Music, Calendar, Mail,
  User, Layout, Palette, Settings, ExternalLink, Newspaper, Copy, Quote, Star,
  Briefcase, Users, HelpCircle, MessageSquare, Phone, CheckCircle2, XCircle, AlertTriangle, Link, RefreshCw
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '@/components/ui/select';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';
import api from '@/lib/api';
import CloudinaryUploader, { GalleryUploader } from '@/components/CloudinaryUploader';

export const SocialLinksEditor = ({ data, onChange }) => {
  const links = data.links || [];
  
  const platforms = [
    'Instagram', 'Facebook', 'Twitter / X', 'YouTube', 'TikTok', 
    'Spotify', 'Apple Music', 'SoundCloud', 'LinkedIn', 'Website'
  ];
  
  const addLink = () => {
    onChange({...data, links: [...links, { platform: '', url: '' }]});
  };
  
  const updateLink = (idx, field, value) => {
    const updated = [...links];
    updated[idx] = {...updated[idx], [field]: value};
    onChange({...data, links: updated});
  };
  
  const removeLink = (idx) => {
    onChange({...data, links: links.filter((_, i) => i !== idx)});
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <Label>Social Media Links</Label>
        <Button variant="outline" size="sm" onClick={addLink}>
          <Plus className="w-4 h-4 mr-1" /> Add Link
        </Button>
      </div>
      
      {links.length === 0 ? (
        <p className="text-sm text-slate-400 text-center py-8 bg-slate-700/30 rounded-lg border border-slate-600">
          No social links yet. Add your profiles above.
        </p>
      ) : (
        <div className="space-y-3">
          {links.map((link, idx) => (
            <div key={idx} className="flex gap-3 items-center bg-slate-700/50 p-3 rounded-lg border border-slate-600">
              <select 
                value={link.platform} 
                onChange={(e) => updateLink(idx, 'platform', e.target.value)}
                className="w-40 px-3 py-2 border border-slate-300 rounded-md text-sm bg-white text-slate-900"
              >
                <option value="">Select...</option>
                {platforms.map(p => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>
              <Input 
                value={link.url} 
                onChange={(e) => updateLink(idx, 'url', e.target.value)}
                placeholder="https://..."
                className="flex-1"
              />
              <Button variant="ghost" size="icon" onClick={() => removeLink(idx)} className="text-red-400 hover:text-red-300 hover:bg-red-500/20">
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Music Module Editor

